import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import PropTypes from 'prop-types';

import Text from '../Text';

export default function RadioInput({
  id,
  name,
  label,
  color = 'black.100',
  onChange,
  checked,
  value,
}) {
  return (
    <Container>
      <Input
        id={id}
        type="radio"
        value={value}
        name={name}
        checked={checked}
        onChange={onChange}
      />
      <RadioControl checked={checked} />
      <Text
        m="0 0 0 10px"
        variant="subtitle2"
        as="label"
        color={color}
        htmlFor={id}
      >
        {label}
      </Text>
    </Container>
  );
}

RadioInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  value: PropTypes.string,
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const RadioControl = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border-width: 2px;
  border-style: solid;
  border-color: ${({ checked }) =>
    checked ? themeGet('colors.primary.100') : themeGet('colors.black.60')};
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 20px;
  width: 20px;

  &:checked + ${RadioControl} {
    background: radial-gradient(
      ${themeGet('colors.primary.100')} 50%,
      rgba(255, 0, 0, 0) 51%
    );
  }
`;
